import {
  SELLERS_FETCHITEMS_LOAD,
  SELLERS_FETCHITEMS_SUCCEED,
  SELLERS_FETCHITEMS_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case SELLERS_FETCHITEMS_LOAD:
      return { ...state, isFetchSellersLoading: true, fetchSellersError: null }
    case SELLERS_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchSellersLoading: false,
        sellers: action.items,
      }
    case SELLERS_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchSellersLoading: false,
        sellers: null,
        fetchSellersError: action.fetchSellersError,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/sellers.js